import React from "react";
import { motion } from "framer-motion";
import { ArrowLeft, ArrowUpRight } from "lucide-react";

const otherWork = [
  {
    title: "Weather App",
    category: "College work",
    description: "A small frontend build using API data and responsive UI.",
  },
  {
    title: "Landing Page Experiments",
    category: "UI experiments",
    description: "A collection of visual layout tests, colour systems and interaction ideas.",
  },
  {
    title: "Firebase Auth Build",
    category: "Random builds",
    description: "A practice project exploring authentication, data storage and protected pages.",
  },
];

export default function OtherWork() {
  return (
    <main className="min-h-screen bg-[#240711] px-6 py-8 text-white">
      <div className="mx-auto max-w-7xl">
        <a href="/" className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-emerald-100 transition">
          <ArrowLeft size={16} />
          Back to home
        </a>

        <header className="py-20 text-center">
          <p className="font-mono text-xs uppercase tracking-[0.45em] text-emerald-100/70">
            Archive
          </p>
          <h1 className="mt-6 text-6xl font-black tracking-tight md:text-8xl">
            Other Work
          </h1>
          <p className="mx-auto mt-8 max-w-3xl text-xl leading-9 text-white/65">
            A collection of smaller builds, experiments, college projects, design bits and random ideas created over the years.
          </p>
        </header>

        <section className="grid gap-6 md:grid-cols-3 mb-20">
          {otherWork.map((item, index) => (
            <motion.article
              key={item.title}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.08 }}
              className="group rounded-[2rem] border border-white/10 bg-[#4a1021] p-7 transition hover:-translate-y-3 hover:border-emerald-100/30 cursor-pointer"
            >
              <div className="flex items-start justify-between gap-4">
                <span className="rounded-full border border-emerald-100/20 bg-white/8 px-3 py-1 font-mono text-[0.65rem] uppercase tracking-[0.2em] text-emerald-100 flex-shrink-0">
                  {item.category}
                </span>
                <ArrowUpRight className="text-emerald-100 transition group-hover:translate-x-1 group-hover:-translate-y-1 flex-shrink-0" />
              </div>

              <h2 className="mt-10 text-3xl font-black">{item.title}</h2>
              <p className="mt-4 leading-7 text-white/65">{item.description}</p>
            </motion.article>
          ))}
        </section>
      </div>
    </main>
  );
}
